import { useEffect } from "react";

import { withHeader } from "@impero-com/common/utils/header";
import withI18n from "@impero-com/common/utils/i18n";
import { HelmetProvider } from "react-helmet-async";
import { Route, Routes } from "react-router-dom";

import { HelpMenu } from "components/HelpMenu";

import { FlipperStrictMode } from "../components/flipperStrictMode";
import { ENVIRONMENT } from "../env";
import { OAuthConsentPage } from "../oauth/OAuthConsentPage";
import { useNewMenu } from "../org/navigation/useNewMenu";
import { OrgDebugPanel } from "../org/OrgDebugPanel";
import { OrgRoutes } from "../org/orgRoutes";
import { OrgSessionTimeoutOverlay } from "../org/sessionTimeoutOverlay";
import { WebRoute } from "../routes";
import { initializePendo } from "../utils/pendo/initializePendo";

function App() {
    return (
        <Routes>
            <Route
                path={WebRoute.OAUTH_AUTHORIZE}
                element={<OAuthConsentPage />}
            />
            <Route path="*" element={<AuthenticatedOrgApp />} />
        </Routes>
    );
}

function AuthenticatedOrgApp() {
    const newMenu = useNewMenu();

    useEffect(() => {
        initializePendo(ENVIRONMENT.PENDO_API_KEY);
    }, []);

    return (
        <FlipperStrictMode boundaryKey="orgEntry">
            <HelmetProvider>
                <OrgRoutes />
                <OrgSessionTimeoutOverlay />
                <OrgDebugPanel />
                {!newMenu && <HelpMenu />}
            </HelmetProvider>
        </FlipperStrictMode>
    );
}
export const AppAuthenticated = withI18n(withHeader(App));
